import { Component, OnInit, Inject, ViewChild, AfterViewInit } from "@angular/core";
// import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ItineraryService } from "../itinerary.service";
import { UserService } from "../../pages/com.usblick.common/auth/user.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { setting } from '../../../../setting';
import { RestService } from "../rest.service";
import { OwlOptions } from "ngx-owl-carousel-o";

@Component({
  selector: "usb-modal-loading",
  templateUrl: "./modal-loading.component.html",
  styleUrls: ["./modal-loading.component.scss"],
})
export class ModalLoadingComponent implements OnInit {
  @ViewChild('owlElement') owlElement: any;
  urlSafe: SafeResourceUrl;
  children = 0;
  adults = 0;
  data: any;
  slides: any = [];
  public baseUrl: string;
	public apiBookingUrl: string;
	public domain: string;
	public getClientsSettingAppBooking: any;
  public routeUploadFile:any;
	public loadSetting : boolean;
  public sectionModalLoading: any;
  public formData: any = {};
  public destination: any;
  optionsTabName:string = '';
  tabNameOrig:string = '';
  imgZonesArr:any[] = [];
  loadingProducts: boolean = false;
  ageDriver:number = 0;
  initialAge:number = 21;
  limitAge:number = 24;
  category: number = 0;
  routerStorage: string;
  imgZone: boolean = false;

  customOptionsModalLoading: OwlOptions = {
    autoHeight: true,
    loop: true,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplaySpeed: 750,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    items: 1,

    }


  constructor(
    public userService: UserService,
    @Inject(MAT_DIALOG_DATA) public payload: any,
    public dialogRef: MatDialogRef<ModalLoadingComponent>,
    public sanitizer: DomSanitizer,
    private restService:RestService,
  ) {
    this.routeUploadFile =  setting.apiStorageBooking;
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.sectionModalLoading  = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_modal_loading);
    this.restService.optionsTab$.subscribe((res:any) => {
      if(res !== undefined && res !== null && res !== '') {
        if(res === 'HOTELS'){
          this.optionsTabName = 'hoteles';
        }else{
          this.optionsTabName = res;
        }
      }
    })
  }

  ngOnInit() {
    this.routerStorage = setting.apiBookingUrl;
    this.formData = JSON.parse(localStorage.getItem("form"));
    this.payload = JSON.parse(localStorage.getItem("payload"));
    this.category = this.payload[0].categoriesId[0];
    if(this.payload && this.payload.length > 0){
      this.data = this.payload[0];
    }else{
      this.data = this.payload;
    }
    switch (this.category) {

      case 1 :  // hotel

        if (this.formData) {
          this.imgZonesArr = this.formData?.destination?.inmg_zones;
        }

        for (let index = 0; index < this.sectionModalLoading?.slide.length; index++) {
          this.slides[index] =  { image: this.routeUploadFile + this.sectionModalLoading?.slide[index], text:index }
        }
      const rooms = this.data.others.hotels.roomConfiguration;
      rooms.forEach((room) => {
        this.children += this.data ? room["children"].length : 0;
        this.adults += this.data ? parseInt(room["adults"]) : 0;
      });

      break;


      case 2:  // rentacar

      this.imgZonesArr = this.formData?.origin?.img_zones;

      break;


      case 6:  // tour
      case 9:
        this.imgZonesArr = this.formData?.destination?.img_zones;
        break;
      case 8:
        // for (let index = 0; index < this.sectionModalLoading?.slide.length; index++) {
        //   this.slides[index] =  { image: this.routeUploadFile + this.sectionModalLoading?.slide[index], text:index }
        // }

        if (this.formData) {
          this.imgZonesArr = this.formData?.firstOrigin?.img_zones;
        }
          const vehicles = this.data?.transfers?.paxList;


        this.children += this.data ? vehicles["children"]?.length : 0;
        this.adults += this.data ? parseInt(vehicles["adults"]) : 0;

      break;

      case 10:
        this.imgZonesArr = this.formData?.destination?.img_zones;
      break;


      default:
      break;
    }
    if (this.imgZonesArr && this.imgZonesArr.length >0) {
      this.imgZone = true;
    }
    this.sendValueObs();
    this.getTabName();


  }


  closeModal(): void {
    this.dialogRef.close();


  }

  sendValueObs():void{
    this.restService.numberAdultsObs$.next(this.adults)
  }

  getTabName():void{
    let payload = JSON.parse(localStorage.getItem("payload"));

    switch (payload[0].categoriesId[0]) {
      case 1:
        this.tabNameOrig = 'Hoteles'
        break;
      case 2:
        this.tabNameOrig = 'RENT-A-CAR'
      break;
      case 6:
        this.tabNameOrig = 'Experiencias'
        break;
      case 8:
        this.tabNameOrig = 'Transportes'
        break;
      case 9:
        this.tabNameOrig = 'Tickets'
        break;
      case 10:
        this.tabNameOrig = 'Asistencias'
        break;
      default:
        break;
    }
  }

  extractNameTransport(form: any, type: string): string {
    switch(type) {
      case 'origin':
        switch(this.payload[0].transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.hotel_name} (${form.destination_code})`;
          case 'airport':
            return `${form.name} (${form.iata}) `;
          case 'destination':
            return `${form.city_name} (${form.country_code})`;
        }
      case 'destination':
        switch(this.payload[0].transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.hotel_name} (${form.destination_code})`;
          case 'airport':
            return `${form.name} (${form.iata}) `;
          case 'destination':
            return `${form.city_name} (${form.country_code})`;
        }
    }
  }

  getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  const messageFly = 'Hora arribo del vuelo';
  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }

  validateChildren(children:any){
    if(children){
      const ageChildren = this.children > 1 ? ` | ${children} Niños` : ` | ${children} Niño`
      return ageChildren;
    }
  }

  getCategorySearching(): string {
    if(!this.category) {
      return '';
    }

    switch(this.category) {
      case 1: return 'Hoteles';
      case 2: return 'Coches';
      case 3: return 'Vuelos';
      case 6: return 'Experiencias';
      case 8: return 'Traslados';
      case 9: return 'Tickets';
      case 10: return 'Asistencias';
    }
  }

    /**
* Método para obtener la imagen del logotipo de la agencia.
*
* Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
* Si la imagen no está disponible o es igual a la ruta del archivo de la API,
* retorna una imagen por defecto.
*
* @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
*/
get agencyImagen(): string {
  let agencyImagen = this.userService._imagen_logotype;
  if (agencyImagen === this.routerStorage || agencyImagen === '') {
      return agencyImagen =  'assets/img/sin-logo.png';
  } else {
      return agencyImagen;
  }
}

}
